__turbopack_context__.v({
  "AuthorSlider": "AuthorSlider-module__zCQfma__AuthorSlider",
});
